import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-517c173e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title mb-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ri-git-branch-line me-2" }),
  /*#__PURE__*/_createTextVNode("Visão de Estrutura / URA ")
], -1))
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-refresh-line me-1" }, null, -1))
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Carregando...")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-alert-line me-2" }, null, -1))
const _hoisted_11 = {
  key: 2,
  class: "alert alert-info",
  role: "alert"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-information-line me-2" }, null, -1))
const _hoisted_13 = {
  key: 3,
  class: "ura-tree-svg-wrapper"
}
const _hoisted_14 = ["width", "height"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("filter", {
    id: "shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, [
    /*#__PURE__*/_createElementVNode("feDropShadow", {
      dx: "1",
      dy: "3",
      stdDeviation: "3",
      "flood-opacity": "0.3"
    })
  ])
], -1))
const _hoisted_16 = { class: "links" }
const _hoisted_17 = ["d"]
const _hoisted_18 = { class: "nodes" }
const _hoisted_19 = ["cx", "cy", "r", "fill"]
const _hoisted_20 = ["x", "y"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanFeatureLocked = _resolveComponent("PlanFeatureLocked")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card mb-4 radius-7 plan-locked-wrapper", { 'plan-locked-wrapper--ura': _ctx.disabledByPlan }])
  }, [
    (_ctx.disabledByPlan)
      ? (_openBlock(), _createBlock(_component_PlanFeatureLocked, {
          key: 0,
          overlay: "",
          title: "Visao de Estrutura / URA bloqueada pelo plano",
          message: "Esta visualizacao mostra como categorias, subcategorias, servicos e profissionais formam o fluxo de atendimento automatico. O plano atual nao inclui esse recurso."
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        class: "btn btn-outline-primary btn-sm",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fetchStructure && _ctx.fetchStructure(...args))),
        disabled: _ctx.loading || _ctx.disabledByPlan
      }, [
        _hoisted_4,
        _createTextVNode("Atualizar ")
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createTextVNode(_toDisplayString(_ctx.error), 1)
            ]))
          : (!_ctx.treeData.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode("Nenhuma estrutura encontrada. Verifique o endpoint ou cadastre os dados. ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(), _createElementBlock("svg", {
                  width: _ctx.svgWidth,
                  height: _ctx.svgHeight,
                  class: "ura-tree-svg"
                }, [
                  _hoisted_15,
                  _createElementVNode("g", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
                      return (_openBlock(), _createElementBlock("path", {
                        key: `link-${index}`,
                        d: link.path,
                        fill: "none",
                        stroke: "#6b7280",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        opacity: "0.52"
                      }, null, 8, _hoisted_17))
                    }), 128))
                  ]),
                  _createElementVNode("g", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodes, (node) => {
                      return (_openBlock(), _createElementBlock("g", {
                        key: node.id,
                        class: "node-group"
                      }, [
                        _createElementVNode("circle", {
                          cx: node.x,
                          cy: node.y,
                          r: _ctx.nodeRadius,
                          fill: _ctx.nodeColor(node.type),
                          opacity: "0.9",
                          filter: "url(#shadow)",
                          class: "node-dot"
                        }, null, 8, _hoisted_19),
                        _createElementVNode("text", {
                          x: node.x + _ctx.nodeRadius + 6,
                          y: node.y + 5,
                          "font-size": "12",
                          "font-weight": "600",
                          fill: "#1f2937",
                          stroke: "#ffffff",
                          "stroke-width": "2",
                          "paint-order": "stroke fill",
                          class: "node-text"
                        }, _toDisplayString(node.title), 9, _hoisted_20),
                        _createElementVNode("title", null, _toDisplayString(node.title), 1)
                      ]))
                    }), 128))
                  ])
                ], 8, _hoisted_14))
              ]))
    ])
  ], 2))
}